import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, LOCALE_ID, provideZoneChangeDetection, provideAppInitializer, inject } from '@angular/core';
//import { NgModule, Injector } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AppConfig } from './app.config';
import { AlertComponent } from './_directives';
import { AlertService, AuthenticationService, UserService, PlacementService, SessionService, ActionService, ReportService, RoleService, ClientService, ClientReportService, QaService } from './_services/index';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/index';
import { AuthGuard, UnsavedChangesGuard } from './_guards';
import { ReactiveFormsModule } from '@angular/forms';
import { ResetpasswordComponent } from './reset-password/index';
import { PasswordComponent } from './reset-password/password.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material-module';
import { StringformatterDirective } from '../app/_directives/stringformatter';

//import { SessionsModule } from './sessions/sessions.module';
import { TutorSessionsHomepage } from './sessions/tutor/index'
import { SessionsSearchComponent, SessionTileComponent } from './sessions/shared/index';
import { Data } from './providers/data/data';
import { TutorLandingComponent } from './tutor/landing/tutor.landing.component';
import { UtilitiesService } from './_services/utilities.service';
import { NgChartsModule, ThemeService } from 'ng2-charts';

import { ActionsComponent, ActionMainComponent } from './actions/index';
import { CoordinatorMainComponent } from './coordinator/landing/coordinator.landing.component';
import { MissingSubmissions, MissingSubmissionsComponent } from './submission/index';
import { SearchComponent } from './shared/search/search.component';
import { ReportControlsComponent } from './tutor-reports/report-controls/report.controls';
import { AdministrationService } from './_services/administration.service';
import { HeaderComponent } from './header/header.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { DatePipe } from '@angular/common';
import { SubmissionHistoryDialog, SubmissionHistoryRecords, CrmUserComponent } from './shared/index';
import { CdkDetailRowDirective } from '../app/_directives/cdkdetailrowdirective';
import { ToastComponent } from './shared/toast/toast.component';
import { BaseComponent } from './base.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AppInjector } from './_services/app-injector.service';
import { DropdownDialogComponent } from './shared/dropdown-list-dialog';
import { ClientDataHelper } from '../app/_helpers/client-data-helper';
import { CoordinatorDashboard } from './dashboards/tc-dashboard/tc-dashboard';
import { TcDashboardComponent } from './dashboards/tc-dashboard/tc-dialog.component';
//import { ReportsMenuComponent } from './reports/reports-menu-component';
import { ReportsDetailComponent } from './reports/reports-detail.component';
import { ClientLandingComponent, ClientAdminComponent } from './clients/index';
import { ClientUserComponent } from './clients/admin/add-update-user';
import { HelperService } from './_services/HelperService';
import { SettingsComponent } from './settings/settings.component';
import { InvalidateComponent } from './invalidate/invalidate.component';
import { NumberOnlyDirective } from './_directives/numberonly.component';
import { ReportsHomeComponent, ReportsViewComponent, ReportsSentComponent } from './reports/index';
import { QaReportApprovalComponent } from './qa/qa-report-approval/qa-report-approval.component';
import { UserMaintenancePage, UserEditPage, RoleFeatureMatrixComponent } from './admin/user-maintenance';
import { ServiceProcessesPage } from './admin/service-processes';
import { FeatureSwitchesPage } from './admin/feature-switches';
import { AdminEmailComponent } from './shared/admin-ux/admin-email.component';
import { ClientUserAccessComponent } from './clients/admin/client-user-access/client-user-access.component';
import { SafePipe } from './_directives/domsanitizer';
import { ReportsGenerateComponent } from './reports/reports-generate/reports-generate.component';
import { ReportsCombinedComponent } from './reports/reports-combined/reports-combined.component';
import { ReportLookupNoteComponent } from './reports/report-lookup-note/report-lookup-note.component';
import { ReportFormatPickerComponent } from './reports/report-format-picker/report-format-picker.component';
import { AttendanceReportComponent } from './reports/native-reports/attendance-report/attendance-report.component';
import { CohortProgressReportComponent } from './reports/native-reports/cohort-progress-report/cohort-progress-report.component';
import { ProgressOverviewReportComponent } from './reports/native-reports/progress-overview-report/progress-overview-report.component';
import { MilprReportComponent } from './reports/native-reports/milpr-report/milpr-report.component';
import { AddClientRowComponent } from './clients/admin/add-client-row/add-client-row.component';
import { FeatureHelperCheckRenderDirective } from './_helpers/feature-helper/feature-helper-check-render.directive';
import { FeatureHelperCheckReadOnlyDirective } from './_helpers/feature-helper/feature-helper-check-readonly.directive';
import { TutorReportGroupComponent } from './tutor-reports/tutor-report-group/tutor-report-group.component';
import { AdLoginComponent } from './ad-login/ad-login.component';
import { MsalModule, MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { PlacementSearchComponent } from './placement-search/placement-search.component';
import { SharedModule } from './shared/shared.module';
import { StudentsComponent } from './students/students.component';
import { AddStudentComponent } from './students/add-student/add-student.component';
import { StudentLoginComponent } from './student-login/student-login.component';
import { StudentHomeComponent } from './students/student-home/student-home.component';
import { StudentOnlineLessonsComponent } from './students/student-online-lessons/student-online-lessons.component';
import { StudentGroupMaintenanceComponent } from './maintenance/student-group-maintenance/student-group-maintenance.component';
import { StudentPasswordGenerateComponent } from './students/student-password-generate/student-password-generate.component';
import { UnauthorisedUserLogoutInterceptor } from './_helpers/unauthorised-user-logout.interceptor';
import { ErrorSupportInterceptor } from './_helpers/error-support.interceptor';
import { LoadingInterceptor } from './_helpers/loading.interceptor';
import { GlobalErrorHandler } from './_helpers/global-error-handler';
import { GenerateStudentAccessModalComponent } from './students/generate-student-access-modal/generate-student-access-modal.component';
import { ManualAddModalComponent } from './students/add-student/manual-add-modal/manual-add-modal.component';
import { UploadAddModalComponent } from './students/add-student/upload-add-modal/upload-add-modal.component';
import { LearningBandTableModalComponent } from './tutor-reports/learning-band-table-modal/learning-band-table-modal.component';
import { AppNewBaseComponent } from './app-new-base/app-new-base.component';
import { IframeWrapperComponent } from './iframe-wrapper/iframe-wrapper.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SessionDatePickerModalComponent } from './tutor-reports/tutor-reports.sessions/session-date-picker-modal/session-date-picker-modal.component';
import { SessionOverviewComponent } from './session-overview/session-overview.component';
import { FaqComponent } from './faq/faq.component';
import { FaqModalComponent } from './faq/faq-modal/faq-modal.component';
import { SessionOverviewSessionBlocksComponent } from './session-overview/session-overview-session-blocks/session-overview-session-blocks.component';
import { ItemsPerPipe } from './_helpers/ngFor-take-items-per-loop.pipe';
import { CookieService } from 'ngx-cookie-service';
import { SessionOverviewSessionCalendarComponent } from './session-overview/session-overview-session-calendar/session-overview-session-calendar.component';
import { SessionOverviewPlacementMainComponent } from './session-overview/session-overview-placement-main/session-overview-placement-main.component';
import { ClientStudentsComponent } from './external/client-students/client-students.component';
import { ClientBookingsComponent } from './external/client-bookings/client-bookings.component';
import { FaqAnswersComponent } from './faq/faq-answers/faq-answers.component';
import { TuitionReportComponent } from './external/tuition-report/tuition-report.component';
import { TuitionFeedbackComponent } from './student-voice/components/tuition-feedback/tuition-feedback.component';
import { ExternalStudentFeedbackComponent } from './external/external-student-feedback/external-student-feedback.component';
import { SendStudentFeedbackLinkModalComponent } from './student-voice/send-student-feedback-link-modal/send-student-feedback-link-modal.component';
import { FeedbackModalComponent } from './student-voice/feedback-modal/feedback-modal.component';
import { HeaderUserConsoleComponent } from './header/header-user-console/header-user-console.component';
import { UtilityBarComponent } from './utility-bar/utility-bar.component';
import { StudentVoiceComponent } from './student-voice/student-voice.component';
import { BarChartComponent } from './dashboards/components/bar-chart/bar-chart.component';
import { BubbleChartComponent } from './dashboards/components/bubble-chart/bubble-chart.component';
import { LineChartComponent } from './dashboards/components/line-chart/line-chart.component';
import { PieChartComponent } from './dashboards/components/pie-chart/pie-chart.component';
import { RadarChartComponent } from './dashboards/components/radar-chart/radar-chart.component';
import { DoughnutChartComponent } from './dashboards/components/doughnut-chart/doughnut-chart.component';
import { StudentFeedbackDashboardComponent } from './dashboards/student-feedback-dashboard/student-feedback-dashboard.component';
import { DashboardMainItemSectionComponent } from './dashboards/student-feedback-dashboard/sections/dashboard-main-item-section/dashboard-main-item-section.component';
import { DashboardAdditionalInfoSectionComponent } from './dashboards/student-feedback-dashboard/sections/dashboard-additional-info-section/dashboard-additional-info-section.component';
import { GaugeChartComponent } from './dashboards/components/gauge-chart/gauge-chart.component';
import { HorizontalFulfillmentGaugeComponent } from './dashboards/components/horizontal-fulfillment-gauge/horizontal-fulfillment-gauge.component';
import { SearchableSelectComponent } from './shared/searchable-select/searchable-select.component';
import { NativeDateValueAccessor } from './shared/native-date/native-date-value-accessor.directive';
import { TestComponent } from './test/test.component';
import { SendBulkStudentAccessLinkComponent } from './students/send-bulk-student-access-link/send-bulk-student-access-link.component';
import { GroupStudentListComponent } from './tutor-reports/tutor-report-group/group-student-list/group-student-list.component';
import { GroupStudentInfoComponent } from './tutor-reports/tutor-report-group/group-student-info/group-student-info.component';
import { AutomationLoginComponent } from './automation-login/automation-login.component';
import { StudentOutcomesComponent, TutorReportsBaselineComponent, TutorReportsComponent, TutorReportsOutcomeDetailComponent } from './tutor-reports';
import { TutorReportTimelineComponent } from './tutor-reports/tutor-report-timeline/tutor-report-timeline.component';
import { AwardSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/award-section/award-section.component';
import { DocumentSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/document-section/document-section.component';
import { ProgressSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/progress-section/progress-section.component';
import { HomeworkSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/homework-section/homework-section.component';
import { ObservationSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/observation-section/observation-section.component';
import { MilestoneEventSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/milestone-event-section/milestone-event-section.component';
import { ActivitySectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/activity-section/activity-section.component';
import { QuizSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/quiz-section/quiz-section.component';
import { TargetsSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/targets-section/targets-section.component';
import { MilestoneSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/milestone-section/milestone-section.component';
import { TimelineNavComponent } from './tutor-reports/tutor-report-timeline/timeline-nav/timeline-nav.component';
import { TimelineDirective } from './_directives/timeline.directive';
import { TutorReportLearnerJourneyFlowComponent } from './tutor-reports/tutor-report-flows/tutor-report-learner-journey-flow/tutor-report-learner-journey-flow.component';
import { PlacementUtilityHeaderComponent } from './tutor-reports/shared/placement-utility-header/placement-utility-header.component';
import { TutorReportLeapV2Component } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/tutor-report-leap-v2.component';
import { LeapV2SessionMetaCardComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-session-meta-card/leap-v2-session-meta-card.component';
import { LeapV2AttendanceCardComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-attendance-card/leap-v2-attendance-card.component';
import { LeapV2StudentPanelComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-student-panel/leap-v2-student-panel.component';
import { LeapV2AttainmentBarComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-attainment-bar/leap-v2-attainment-bar.component';
import { LeapV2EngagementBarComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-engagement-bar/leap-v2-engagement-bar.component';
import { LeapV2EvidenceUploadComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-evidence-upload/leap-v2-evidence-upload.component';
import { LeapV2ScaleSliderComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-scale-slider/leap-v2-scale-slider.component';
import { LeapV2DeltaComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-delta/leap-v2-delta.component';
import { LeapV2IlpComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-ilp/leap-v2-ilp.component';
import { LeapV2ProgressReportComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/leap-v2-progress-report/leap-v2-progress-report.component';
import { LeapV2AttendanceDialogComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/dialogs/leap-v2-attendance-dialog/leap-v2-attendance-dialog.component';
import { LeapV2TutorCancelledDialogComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/dialogs/leap-v2-tutor-cancelled-dialog/leap-v2-tutor-cancelled-dialog.component';
import { LeapV2BehaviouralConcernDialogComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/dialogs/leap-v2-behavioural-concern-dialog/leap-v2-behavioural-concern-dialog.component';
import { LeapV2ConsultantNotesDialogComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/dialogs/leap-v2-consultant-notes-dialog/leap-v2-consultant-notes-dialog.component';
import { LeapV2DebugDialogComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/dialogs/leap-v2-debug-dialog/leap-v2-debug-dialog.component';
import { ProgressReportListDialogComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/dialogs/progress-report-list-dialog/progress-report-list-dialog.component';
import { MilestoneModalComponent } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/dialogs/milestone-modal/milestone-modal.component';
import { RiskAssessmentDialogComponent } from './tutor-reports/tutor-report-flows/tutor-report-learner-journey-flow/dialogs/risk-assessment-dialog/risk-assessment-dialog.component';
import { ViewStudentBookingsComponent } from './student-bookings/view-student-bookings/view-student-bookings.component';
import { SectionBaseComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/section-base/section-base.component';

import {
  StudentBookingsComponent,
  StudentBookingStudentDetailsComponent
} from './student-bookings/index';
import { ScaleRaterComponent } from './shared/scale-rater/scale-rater.component';
import { StudentSearchModalComponent } from './shared/student-search/student-search-modal.component';
import { EditLearningSectionModalComponent } from './tutor-reports/tutor-report-timeline/modals/edit-learning-section-modal/edit-learning-section-modal.component';
import { SessionSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/session-section/session-section.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClassicSessionSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/classic-session-section/classic-session-section.component';
import { ClassicProgressSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/classic-progress-section/classic-progress-section.component';
import { ClassicIlpSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/classic-ilp-section/classic-ilp-section.component';
import { LeapV2IlpSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/leap-v2-ilp-section/leap-v2-ilp-section.component';
import { LeapV2ProgressReportSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/leap-v2-progress-report-section/leap-v2-progress-report-section.component';
import { LeapV2SessionSectionComponent } from './tutor-reports/tutor-report-timeline/timeline-sections/leap-v2-session-section/leap-v2-session-section.component';
import { SelectTimelineSubjectComponent } from './tutor-reports/select-timeline-subject/select-timeline-subject.component';
import { SelectTimelineSubjectModalComponent } from './tutor-reports/select-timeline-subject/select-timeline-subject-modal/select-timeline-subject-modal.component';
import { StudentViewTimelineComponent } from './tutor-reports/student-view-timeline/student-view-timeline.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { OnlineLessonOverviewComponent } from './dashboards/online-lesson-overview/online-lesson-overview.component';
import { VideoLibraryTileComponent } from './dashboards/video-library-tile/video-library-tile.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { LeapV2SessionService } from './tutor-reports/tutor-report-flows/tutor-report-leap-v2/services/leap-v2-session.service';


@NgModule({ declarations: [
        BaseComponent,
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        LoginComponent,
        RegisterComponent,
        AlertComponent,
        ResetpasswordComponent,
        PasswordComponent,
        TutorReportsComponent,
        TutorReportsBaselineComponent,
        TutorReportsOutcomeDetailComponent,
        StudentOutcomesComponent,
        StringformatterDirective,
        TutorSessionsHomepage,
        SessionsSearchComponent,
        SessionTileComponent,
        TutorLandingComponent,
        ActionsComponent,
        ActionMainComponent,
        CoordinatorMainComponent,
        MissingSubmissionsComponent,
        MissingSubmissions,
        SearchComponent,
        ReportControlsComponent,
        HeaderComponent,
        SubmissionHistoryDialog,
        SubmissionHistoryRecords,
        CdkDetailRowDirective,
        CrmUserComponent,
        ToastComponent,
        DropdownDialogComponent,
        CoordinatorDashboard,
        TcDashboardComponent,
        ReportsViewComponent,
        ReportsDetailComponent,
        AttendanceReportComponent,
        CohortProgressReportComponent,
        ProgressOverviewReportComponent,
        MilprReportComponent,
        ClientLandingComponent,
        ClientAdminComponent,
        ClientUserComponent,
        SettingsComponent,
        InvalidateComponent,
        NumberOnlyDirective,
        ReportsHomeComponent,
        QaReportApprovalComponent,
        UserMaintenancePage,
        UserEditPage,
        RoleFeatureMatrixComponent,
    ServiceProcessesPage,
    FeatureSwitchesPage,
        ReportsSentComponent,
        SafePipe,
        ReportsGenerateComponent,
        ReportsCombinedComponent,
        AddClientRowComponent,
        FeatureHelperCheckRenderDirective,
        FeatureHelperCheckReadOnlyDirective,
        TutorReportGroupComponent,
        AdLoginComponent,
        PlacementSearchComponent,
        StudentsComponent,
        AddStudentComponent,
        StudentLoginComponent,
        StudentHomeComponent,
        StudentOnlineLessonsComponent,
        StudentGroupMaintenanceComponent,
        StudentPasswordGenerateComponent,
        GenerateStudentAccessModalComponent,
        ManualAddModalComponent,
        UploadAddModalComponent,
        LearningBandTableModalComponent,
        AppNewBaseComponent,
        IframeWrapperComponent,
        SessionDatePickerModalComponent,
        SessionOverviewComponent,
        FaqComponent,
        FaqModalComponent,
        SessionOverviewSessionBlocksComponent,
        ItemsPerPipe,
        SessionOverviewSessionCalendarComponent,
        SessionOverviewPlacementMainComponent,
        ClientStudentsComponent,
        ClientBookingsComponent,
        FaqAnswersComponent,
        TuitionReportComponent,
        TuitionFeedbackComponent,
        ExternalStudentFeedbackComponent,
        SendStudentFeedbackLinkModalComponent,
        FeedbackModalComponent,
        HeaderUserConsoleComponent,
        UtilityBarComponent,
        StudentVoiceComponent,
        BarChartComponent,
        BubbleChartComponent,
        LineChartComponent,
        PieChartComponent,
        RadarChartComponent,
        DoughnutChartComponent,
        StudentFeedbackDashboardComponent,
        DashboardMainItemSectionComponent,
        DashboardAdditionalInfoSectionComponent,
        GaugeChartComponent,
        HorizontalFulfillmentGaugeComponent,
        TestComponent,
        SearchableSelectComponent,
        NativeDateValueAccessor,
        SendBulkStudentAccessLinkComponent,
        GroupStudentListComponent,
        GroupStudentInfoComponent,
        AutomationLoginComponent,
        TutorReportLearnerJourneyFlowComponent,
        PlacementUtilityHeaderComponent,
        TutorReportLeapV2Component,
        LeapV2SessionMetaCardComponent,
        LeapV2AttendanceCardComponent,
        LeapV2StudentPanelComponent,
        LeapV2AttainmentBarComponent,
        LeapV2EngagementBarComponent,
        LeapV2EvidenceUploadComponent,
        LeapV2ScaleSliderComponent,
        LeapV2DeltaComponent,
        LeapV2IlpComponent,
        LeapV2ProgressReportComponent,
        LeapV2AttendanceDialogComponent,
        LeapV2TutorCancelledDialogComponent,
        LeapV2BehaviouralConcernDialogComponent,
        LeapV2ConsultantNotesDialogComponent,
        RiskAssessmentDialogComponent,
        LeapV2DebugDialogComponent,
        ProgressReportListDialogComponent,
        MilestoneModalComponent,
        ViewStudentBookingsComponent,
        TutorReportTimelineComponent,
        AwardSectionComponent,
        DocumentSectionComponent,
        ProgressSectionComponent,
        HomeworkSectionComponent,
        ObservationSectionComponent,
        MilestoneEventSectionComponent,
        ActivitySectionComponent,
        QuizSectionComponent,
        TargetsSectionComponent,
        MilestoneSectionComponent,
        TimelineNavComponent,
        TimelineDirective,
        StudentBookingsComponent,
        StudentBookingStudentDetailsComponent,
        ScaleRaterComponent,
        SessionSectionComponent,
        StudentSearchModalComponent,
        SectionBaseComponent,
        EditLearningSectionModalComponent,
        ClassicSessionSectionComponent,
        ClassicProgressSectionComponent,
        ClassicIlpSectionComponent,
        LeapV2IlpSectionComponent,
        LeapV2ProgressReportSectionComponent,
        LeapV2SessionSectionComponent,
        SelectTimelineSubjectComponent,
        SelectTimelineSubjectModalComponent,
        StudentViewTimelineComponent,
        OnlineLessonOverviewComponent,
        VideoLibraryTileComponent
    ],
    exports: [
        MatTabsModule,
        MatSidenavModule
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        ReportLookupNoteComponent,
        ReportFormatPickerComponent,
        AdminEmailComponent,
        ClientUserAccessComponent,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        AppRoutingModule,
        MatExpansionModule,
        MatIconModule,
        FlexLayoutModule,
        MatToolbarModule,
        MatCardModule,
        MatButtonModule,
        MatSidenavModule,
        NgSelectModule,
        AngularSvgIconModule.forRoot(),
        SharedModule,
        NgxPaginationModule,
        NgChartsModule,
        NgxFileDropModule,
        MsalModule.forRoot(
          new PublicClientApplication({
            auth: {
              clientId: environment.applicationId,
              authority: `https://login.microsoftonline.com/${environment.directoryId}`,
              // Return to /signmein — the ONLY route that calls handleRedirectObservable() and then
              // authenticateAdUser (bootstrap is AppComponent, not MsalRedirectComponent). With the
              // bare origin here, Entra returned the user to the login page, which has no redirect
              // handler, so the first sign-in appeared to do nothing and the user had to click
              // "Supporting Education Group Access" a second time to complete — the "double page"
              // flow. The app registration's SPA redirect URI must match this exactly.
              redirectUri: window.location.origin + '/signmein',
              // Where Entra returns the user after a GLOBAL sign-out. Nothing calls logoutRedirect()
              // today — sign-out is local via clearCache(), see login.component — but MSAL defaults
              // this to redirectUri when unset, which would land a logged-out user on /signmein: a
              // sign-IN handler with no account to handle. Pin it to the login page so that reverts
              // to something sensible if a global sign-out is ever reintroduced.
              postLogoutRedirectUri: window.location.origin + '/login',
            },
            cache: { cacheLocation: 'localStorage' }
          }),
          { interactionType: InteractionType.Redirect, authRequest: { scopes: ['user.read'] } },
          { interactionType: InteractionType.Redirect, protectedResourceMap: new Map() }
        )
    ], providers: [
        AuthGuard,
        UnsavedChangesGuard,
        AlertService,
        AuthenticationService,
        UserService,
        PlacementService,
        SessionService,
        AppConfig,
        Data,
        ActionService,
        AdministrationService,
        DatePipe,
        UtilitiesService,
        ClientDataHelper,
        ReportService,
        ClientReportService,
        QaService,
        RoleService,
        ClientService,
        HelperService,
        CookieService,
      ThemeService,
      LeapV2SessionService,
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: UnauthorisedUserLogoutInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorSupportInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
      { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: LOCALE_ID, useValue: 'en-GB' },
        provideHttpClient(withInterceptorsFromDi()),
        // msal-browser v5 requires instance.initialize() to be awaited before ANY MSAL call. We
        // bootstrap AppComponent (not MsalRedirectComponent), so nothing initialised it — and
        // login.component.ts's ngOnInit calls getAllAccounts() on load, which threw
        // uninitialized_public_client_application and broke the whole login page (form login
        // included). Block bootstrap on initialize() so the instance is ready everywhere.
        provideAppInitializer(() => inject(MsalService).instance.initialize()),
        // Angular 21's default scheduler is stricter about state mutated without a zone notification,
        // producing a wave of dev-only NG0100s in legacy zone.js apps (angular-cli#32047). Explicitly
        // opt in to zone-based change detection semantics until the app migrates to OnPush/signals.
        provideZoneChangeDetection(),
    ] })
export class AppModule {
  constructor(injector: Injector) {AppInjector.setInjector(injector);}
};
